export default __webpack_public_path__ + "static/media/nonalcoholic.527df91c.png";